import { AfterViewInit, Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { GlobalService } from 'src/app/shared/services/global.service';

@Component({
    selector: 'app-unauthorized',
    templateUrl: './unauthorized.component.html',
    styleUrls: ['./unauthorized.component.scss'],
    standalone: false
})
export class UnauthorizedComponent implements OnInit, AfterViewInit {
  constructor(private _router: Router, private globalService: GlobalService) {}

  ngOnInit(): void {}

  goHome() {
    this.globalService.clearCurCache = false;

    this._router.navigate(['/home']);
  }

  ngAfterViewInit() {
    setTimeout(() => {
    this.globalService.title.push(this.globalService.screenHeader);
    this.globalService.screenHeader = "Notification";
    });
  }       
}
 